import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useHttpStatus, useComparable } from '../hooks';
import ListTable from './ListTable.jsx';
import ListPagination from './ListPagination.jsx';
import AnimPending from './AnimPending.jsx';
import FormHttpAlert from './FormHttpAlert.jsx';
import isEqual from 'lodash/isEqual';

const useURLQuery = ({skip, limit, sort, filter}) => {
  const location = useLocation();
  const history = useHistory();

  let uParams = new URLSearchParams(location.search);
  let uSkip = uParams.get('skip') || skip;
  let uLimit = uParams.get('limit') || limit;
  let uSort = sort;
  try {
    if ( uParams.get('sort') ) {
      uSort = JSON.parse(uParams.get('sort'));
    }
  } catch ( e ) {}
  let uFilter = filter;
  try {
    if ( uParams.get('filter') ) {
      uFilter = JSON.parse(uParams.get('filter'));
    }
  } catch ( e ) {}

  const query = {
    skip: uSkip,
    limit: uLimit,
    sort: uSort,
    filter: uFilter,
  };

  const updateQuery = (q) => {
    // console.log( 'updateQuery', query, q, skip, limit, sort)
    let params = {
      ...query,
      ...q,
    }
    // console.log( 'params', JSON.stringify(params) );
    let filterChangeOnly = (q.filter != null );
    if ( query.limit != params.limit ) filterChangeOnly = false;
    if ( query.skip != params.skip ) filterChangeOnly = false;
    if ( query.sort !== params.sort ) filterChangeOnly = false;
    let urlSearchParams = new URLSearchParams();
    if ( params.skip != skip ) {
      urlSearchParams.append('skip', params.skip);
    }
    if ( params.limit != limit ) {
      urlSearchParams.append('limit', params.limit);
    }
    if ( params.sort != sort ) {
      urlSearchParams.append('sort', JSON.stringify(params.sort));
    }
    if ( filter && Object.keys(filter).length > 0 ) {
      urlSearchParams.append('filter', JSON.stringify(params.filter));
    }

    let search = urlSearchParams.toString();
    if ( search != '' ) {
      search = "?"+search;
    }
    // console.log( search );
    // console.log( location.search );
    // console.log( search != location.search ) 
    if (  search != location.search ) {
      // console.log( 'filterChangeOnly', filterChangeOnly, query.filter);
      // console.log( uParams.get('filter') )
      if ( uParams.get('filter') == null || !filterChangeOnly ) {
        // console.log('push url')
        history.push(location.pathname+search);
      } else {
        // console.log('replace url')
        history.replace(location.pathname+search);
      }
      return false;
    }

    return params;
  }

  return [query,updateQuery]
}

const ListHttpTable = ({
  api,
  cols,
  skip = 0,
  limit = 20,
  sort,
  filter = {},
  onSelect,
  onRowClick,
  className,
  refresh,
  setRefresh,
  children,
}) => {
  // console.log('ListHttpTable:: render');
  const location = useLocation();

  const [selected, setSelected] = useState([]);
  // const [query, setQuery] = useState({
  //   skip,
  //   limit,
  //   sort,
  // });
  const [
    res,
    req,
    fetched = { rows: [], total: 0 },
  ] = useHttpStatus({
    onSuccess() {
      // clear select
      if (onSelect) {
        setSelected([]);
        onSelect([]);
      }
    },
  });

  const [query, updateQuery] = useURLQuery({skip, limit, sort, filter});

  useEffect(() => {
    // console.log('ListHttpTable::useEffect', location, filter)
    // console.log( 'query.filter', query.filter );
    // console.log( 'isEqual', isEqual(filter, query.filter) );
    var update = isEqual(filter, query.filter) ? {filter} : {skip: 0, filter};
    var nq = updateQuery(update);
    if ( nq ) {
      req({
        ...api,
        params: nq,
      })
    }
    // fetch({ skip: 0 });
  }, [
    refresh,
    useComparable({ filter, api }),
  ]);

  useEffect(()=>{
    // console.log('location/query change!!!')
    // console.log(JSON.stringify(query,null,2))
    req({
      ...api,
      params: query,
    })
  },[location])

  return (
    <div>
      <FormHttpAlert res={res} />
      <div className="form-row mb-3">
        <div className="col">{children}</div>
        <ListPagination
          {...{
            className: 'col-auto',
            ...query,
            total: fetched.total,
            onChange: updateQuery,
          }}
        />
      </div>
      <div className="position-relative">
        {res.status === 'pending' && (
          <div className="position-absolute fill">
            <div className="position-absolute fill bg-white opacity-5" />
            <AnimPending />
          </div>
        )}
        <ListTable
          {...{
            className,
            cols,
            rows: fetched.rows,
            onRowClick,
            selected: onSelect ? selected : null,
            onSelect: onSelect ? (s) => {
              setSelected(s);
              onSelect(s.map((i) => (
                fetched.rows[i]
              )));
            } : undefined,
            sort: query.sort,
            onSort: (s)=>{
              updateQuery({ sort: s })
            },
            refresh,
            setRefresh,
          }}
        />
      </div>
    </div>
  );
};

export default ListHttpTable;
